import { EmploymentFieldsSettings } from './employmentInformationBlock.types';

export const FIELD_SETTINGS: EmploymentFieldsSettings = {
  BusinessName: { label: 'Business Name', isVisible: true, isDisabled: false },
  Position: { label: 'Position', isVisible: true, isDisabled: false },
  HireDate: { label: 'Income Start Date', isVisible: true, isDisabled: false },
};

export const FIELD_MAX_LENGTH = 100;

export const MAX_LENGTH_ERROR_MESSAGE = 'Max length is 100 characters';
